// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__9JTiE","form":"EditProfile_form__GG-AU","userImage":"EditProfile_userImage__thBzo"};